import {Injectable} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class NoosFormTypeService {
    static implementations: object = {};

    static register(typeName: string) {
        const result = <T extends { new(...args: any[]): {} }>(constructor: T) => {

            const CLASS = class extends constructor {
            };

            if (!NoosFormTypeService.implementations.hasOwnProperty(typeName)) {
                NoosFormTypeService.implementations[typeName] = CLASS;
            }

            return CLASS;
        };
        return result;
    }

    constructor() {
    }

    getPostTypeFromString(typeName: string) {
        if (!NoosFormTypeService.implementations.hasOwnProperty(typeName)) {
            // throw new Error('This post type does not exist. Did you forget to @Register() it?');
            return null;
        }
        return NoosFormTypeService.implementations[typeName];
    }
}

